import {
  getCompanyList,
  normalizeCityName,
} from "@/common/helpers/company.helpers";

export const useLeadsByCity = (
  leadsByTime: Record<string, number> | undefined
) => {
  const allCompanies = getCompanyList();
  const activeCompanies = allCompanies.filter((c) => c.active);
  const cityMap = new Map(
    activeCompanies.map((c) => [normalizeCityName(c.name), c.sigla])
  );

  const totalLeadsByCity = Object.values(leadsByTime || {}).reduce(
    (acc, cityEntries) => {
      Object.entries(cityEntries || {}).forEach(([cityName, value]) => {
        const sigla = cityMap.get(normalizeCityName(cityName));
        if (sigla) acc[sigla] = (acc[sigla] || 0) + value;
      });
      return acc;
    },
    {} as Record<string, number>
  );

  const allLeadsByCityEntries = activeCompanies
    .map((c) => [c.name, totalLeadsByCity[c.sigla] || 0] as [string, number])
    .sort(([, a], [, b]) => b - a);

  return { allLeadsByCityEntries };
};
